export const IMMIGRATE_QUESTION_EDIT_SUBMIT_REQUEST = 'immigrate-question/edit-submit-request'
export const IMMIGRATE_QUESTION_EDIT_SUBMIT_SUCCESS = 'immigrate-question/edit-submit-success'
export const IMMIGRATE_QUESTION_EDIT_SUBMIT_FAILED = 'immigrate-question/edit-submit-failed'
